// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var carousel = "SlideCarousel-module--carousel--2ZkY_";
export var image = "SlideCarousel-module--image--35mR9";
export var imageLink = "SlideCarousel-module--imageLink--3oKbP";
export var button = "SlideCarousel-module--button--U_2bk";
export var buttonBack = "SlideCarousel-module--buttonBack--grkXM";
export var buttonNext = "SlideCarousel-module--buttonNext--hHsIw";
export var buttonIcon = "SlideCarousel-module--buttonIcon--kpfvi";
export var bottomBar = "SlideCarousel-module--bottomBar--2yQL5";
export var noDotGroup = "SlideCarousel-module--noDotGroup--2pAB0";
export var text = "SlideCarousel-module--text--1qhgL";
export var dotGroup = "SlideCarousel-module--dotGroup--3BrGQ";